import React from 'react';

import { Eyebrow, normalizeAgents } from 'components/AgentLanding/AgentLandingPrimitives';

const BiographyPage = ({ agentData }) => {
  const agents = normalizeAgents(agentData);
  const isTeam = agents.length > 1;
  return (
    <main className="al-bio">
      <div className="al-shell">
        <Eyebrow>{isTeam ? 'About us' : 'About me'}</Eyebrow>
        <h1>Local experience. Clear guidance.</h1>
        <article>
          {agentData.agentLandingBio || `${isTeam ? 'We' : 'I'} provide local real estate guidance with an emphasis on clear market context, thoughtful strategy, and responsive service.`}
        </article>
      </div>
    </main>
  );
};

export default BiographyPage;
